import { createRouter, createWebHistory } from "vue-router";
import auth from "./auth.middlware.js";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/add",
    name: "add",
    component: () => import("../views/add.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/edit",
    name: "edit",
    props: (route) => ({
      detail: "",
      ...route.params,
    }),
    component: () => import("../views/edit.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/profile.vue"),
  },
  {
    path: "/favorite",
    name: "favorite",
    component: () => import("../views/favorite.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/about.vue"),
  },
  {
    path: "/about/:id",
    component: () => import("../views/About-us.vue"),
    props: true,
    meta: { paramName: "paramValue" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }
  const context = {
    to,
    from,
    next,
    store,
  };
  return to.meta.middleware[0]({
    ...context,
  });
});

export default router;
